import React from "react";

export default function AddTopComponent(props) {
  return (
    <div className="card-header">
      <div className="d-sm-flex mb-lg-4 mb-2">
        <a
          href={props.path}
          onClick={() => {
            window.history.back(window.location.reload());
          }}
          className="btn btn-primary mb-1 mr-1"
        >
          Back
        </a>
      </div>
    </div>
  );
}
